module.exports = __webpack_public_path__ + "static/media/aadhaar.65d36037.svg";